import { useMutation } from '@tanstack/react-query';

import envVars from '../../../../../constants/envVars';
import useRequest from '../../../../../hooks/useRequest';
import { ApiEnvelope } from '../../../types';
import { DrChronoTask, DrChronoTaskError, DrChronoTaskPayload } from '../types';
import useOnTaskSaved from './useOnTaskSaved';

const useCreateDrChronoTask = (member_id: number | null | undefined, onSuccess?: () => void) => {
    const req = useRequest();

    return useMutation<DrChronoTask, DrChronoTaskError, DrChronoTaskPayload>({
        mutationFn: (body) =>
            req<ApiEnvelope<DrChronoTask>>({
                url: `${envVars.API_RTM_HOSTNAME}enterprise/member/${member_id}/drchrono-tasks/`,
                method: 'POST',
                body: JSON.stringify(body)
            }).then((response) => response.data),
        onSuccess: useOnTaskSaved(member_id, 'created', onSuccess),
        onError: (error) => error
    });
};

export default useCreateDrChronoTask;
